import { GuiListAbfall } from "./GuiListAbfall";

export class GuiListKostenstelle extends GuiListAbfall {
}
